import React from 'react';
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from '@heroicons/react/24/outline';

/** Tailwind alert — replaces MUI Alert. severity: 'success' | 'info' | 'warning' | 'error' */
const STYLES = {
  success: { box: 'border-emerald-200 bg-emerald-50 text-emerald-800', Icon: CheckCircleIcon },
  info: { box: 'border-blue-200 bg-blue-50 text-blue-800', Icon: InformationCircleIcon },
  warning: { box: 'border-amber-200 bg-amber-50 text-amber-800', Icon: ExclamationTriangleIcon },
  error: { box: 'border-red-200 bg-red-50 text-red-800', Icon: XCircleIcon },
};

const Alert = ({ severity = 'info', title, children, className = '', action = null }) => {
  const { box, Icon } = STYLES[severity] || STYLES.info;
  return (
    <div className={`flex items-start gap-2.5 rounded-lg border px-3.5 py-2.5 text-sm ${box} ${className}`}>
      <Icon className="mt-0.5 h-5 w-5 flex-shrink-0" />
      <div className="min-w-0 flex-1">
        {title && <div className="font-semibold">{title}</div>}
        {children}
      </div>
      {action}
    </div>
  );
};

export default Alert;
